export default "__VITE_ASSET__CbgJX2vM__"